<template>
  <div class="income-detail-wrap" v-loading="loadingPage">
    <div class="header">
      <div class="title">收益提现</div>
      <div class="chart-data">
        <div class="chart" v-for="(item,index) in chartList" :key="item.value">
          <div class="circle" :class="'bgColor'+(index+1)" :style="item.color">
            {{ item.number }}
          </div>
          <div class="title-name">
            {{ item.title
            }}<span style="color: #ccc; padding-left: 5px"
              >({{ item.unit }})</span
            >
          </div>
        </div>
      </div>
      <div class="search">
        <el-form
          inline
          class="inline-form"
          :model="searchForm"
          label-width="85px"
          label-position="left"
        >
          <el-form-item label="交易时间">
            <el-date-picker
              v-model="auditTime"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="收益状态">
            <el-select v-model="searchForm.profitStatus" placeholder="请选择">
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="search" class="btnBase searchBtn"
            >查询</el-button
          >
          <el-button type="primary" @click="billSend" class="btnBase searchBtn"
            >开票及寄送</el-button
          >
        </el-form>
      </div>
    </div>
    <div class="table-list">
      <div class="tabledata-con">
        <el-table
          :data="tableData"
          style="width: 100%"
          border
          v-loading="loadingTable"
        >
          <el-table-column
            prop="incomeDate"
            label="收益时间"
            align="center"
          ></el-table-column>
          <el-table-column prop="incomeAmount" label="收益金额" align="center">
          </el-table-column>
          <el-table-column prop="withdrawStatus" label="状态" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" @click="toDismiss(scope.row)" v-if='scope.row.profitStatus === 2'>驳回原因</el-button>
              <el-button type="primary" @click="toDismiss(scope.row)" v-if='scope.row.profitStatus === 4'>失败原因</el-button>
              <el-button type="primary" @click="toWithdraw(scope.row)" v-if='scope.row.profitStatus === 2 || scope.row.profitStatus === 4'
                >重新提现</el-button
              >
              <el-button type="primary" @click="toWithdraw(scope.row)" v-if='scope.row.profitStatus === 0'
                >提现</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="paginationBox">
          <el-pagination
            v-if="page.count > 0"
            class="pagination"
            prev-text="上一页"
            next-text="下一页"
            :page-size="page.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="page.count"
            :current-page="page.pageNo"
            @current-change="onChangeCurrentPage"
          >
          </el-pagination>
        </el-col>
      </div>
    </div>
    <el-dialog
      title="开票及寄送信息"
      :visible.sync="dialogAutoSet"
      width="30%"
      class="invoice-dialog"
    >
      <el-form class="inline-form" inline style="margin-top: 20px">
        <el-form-item label="寄送信息:">
          <el-input
            class='sendInput'
            type="textarea"
            v-model="billTable.send"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="开票信息:">
          <el-input
            type="textarea"
            v-model="billTable.bill"
            style="width: 400px"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="审核驳回详情"
      :visible.sync="dismissDetailSet"
      width="25%"
      class="invoice-dialog"
    >
      <el-form class="inline-form" inline style="margin-top: 20px">
        <el-form-item label="驳回原因:">
          <el-input
            type="textarea"
            v-model="dismissTable.reason"
            style="width: 300px"
            readonly
          ></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
// eslint-disable-next-line
import { getProfitDetail, statisticsProfit, getSendAndInvoiceInfo } from "@/api/data-report";
import { formatDate, getTodayStartTimestamp, getTodayEndTimestamp } from '@/utils/index';

export default {
  name: "crash",
  data() {
    return {
      searchForm: {
        startTime: parseInt(formatDate(getTodayStartTimestamp()).split('-').join('').slice(0, 6), 10),
        endTime: parseInt(formatDate(getTodayEndTimestamp()).split('-').join('').slice(0, 6), 10),
        profitStatus: 6,
      },
      page: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      tableData: [],
      chartList: [
        {
          number: "0",
          title: "线下订单数",
          unit: "笔",
        },
        {
          number: "0",
          title: "累计收益",
          unit: "元",
        },
        {
          number: "0",
          title: "已提现收益",
          unit: "元",
        },
        {
          number: "0",
          title: "待提现收益",
          unit: "元",
        },
        {
          number: "0",
          title: "提现中收益",
          unit: "元",
        },
      ],
      statusList: [
        { label: "全部", value: 6 },
        { label: "待提现", value: 0 },
        { label: "提现中", value: 1 },
        { label: "提现失败", value: 2 },
        { label: "待打款", value: 3 },
        { label: "打款失败", value: 4 },
        { label: "已打款", value: 5 },
      ],
      loadingTable: false,
      loadingPage: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      dialogAutoSet: false,
      dismissDetailSet: false,
      billTable: {
        send: "",
        bill: "",
      },
      dismissTable: {
        reason: "",
      },
      auditTime: [formatDate(getTodayStartTimestamp()), formatDate(getTodayEndTimestamp())],
    };
  },
  watch: {
    auditTime(val) {
      if (val) {
        this.searchForm.startTime = parseInt(formatDate(val[0]).split('-').join('').slice(0, 6), 10);
        this.searchForm.endTime = parseInt(formatDate(val[1]).split('-').join('').slice(0, 6), 10);
      } else {
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
      }
    },
  },
  computed: {
    merchantId() {
      return localStorage.getItem("LOGIN_INFO") && JSON.parse(localStorage.getItem("LOGIN_INFO")).merchantId;
    },
    userName() {
      return localStorage.getItem("LOGIN_INFO") && JSON.parse(localStorage.getItem("LOGIN_INFO")).userName;
    },
    sessionId() {
      return localStorage.getItem("LOGIN_INFO") && JSON.parse(localStorage.getItem("LOGIN_INFO")).sessionId;
    },
  },
  methods: {
    search() {
      this.page.pageNo = 1;
      this.queryWithdrawlList();
    },
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.queryWithdrawlList();
    },
    isEmpty(val) {
      if (typeof val === 'undefined' || val === 'null' || val === '') {
        return true;
      }
      return false;
    },
    getWithdrawStatus(e) {
      switch (e) {
        case 0:
          return '待提现';
        case 1:
          return '提现中';
        case 2:
          return '提现失败';
        case 3:
          return '待打款 ';
        case 4:
          return '打款失败';
        case 5:
          return '已打款';
        default:
          return '暂无';
      }
    },
    // 获取提现记录
    queryWithdrawlList() {
      const param = {
        merchantId: this.merchantId,
        userName: this.userName,
        sessionId: this.sessionId,
      };
      const params = Object.assign(param, this.searchForm, this.page);
      // 如果日期为空，不能查询
      if (!params.startTime) {
        this.$message({
          message: '查询日期必传',
          type: 'error',
        });
        return;
      }
      Object.keys(params).forEach((item) => {
        if (this.isEmpty(params[item])) {
          delete params[item];
        }
      });
      this.loadingPage = true;
      getProfitDetail(params).then((res) => {
        if (res.data.error_code === 0) {
          this.loadingPage = false;
          this.tableData = res.data.data.profitDetailEntities;
          this.page.count = res.data.data.totalNum;
          Object.keys(this.tableData).forEach((item) => {
            const date = this.tableData[item].date.toString();
            this.tableData[item].incomeAmount = (this.tableData[item].amount / 100).toFixed(2);
            this.tableData[item].incomeDate = `${date.substr(0, 4)}年${date.substr(4, 2)}月收益`;
            this.tableData[item].withdrawStatus = this.getWithdrawStatus(this.tableData[item].profitStatus);
          });
        } else {
          this.loadingPage = false;
          this.$message({
            message: res.data.error_msg,
            type: "error",
          });
        }
      });
    },
    // 获取头部数据列表
    queryStatistics() {
      const param = {
        merchantId: this.merchantId,
        userName: this.userName,
        sessionId: this.sessionId,
      };
      return statisticsProfit(param).then((res) => {
        if (res.data.error_code === 0) {
          this.chartList[0].number = res.data.data.orderNum;
          this.chartList[1].number = (res.data.data.totalProfit / 100).toFixed(2);
          this.chartList[2].number = (res.data.data.extractProfit / 100).toFixed(2);
          this.chartList[3].number = (res.data.data.readyExtractProfit / 100).toFixed(2);
          this.chartList[4].number = (res.data.data.extractProfitProgress / 100).toFixed(2);
        } else {
          this.$message({
            message: "操作成功",
            type: "error",
          });
        }
      });
    },
    billSend() {
      this.dialogAutoSet = true;
      const param = {
        merchantId: this.merchantId,
        userName: this.userName,
        sessionId: this.sessionId,
      };
      getSendAndInvoiceInfo(param).then((res) => {
        this.billTable.send = `收件人:${res.data.data.receive}\n联系手机:${res.data.data.phoneNumber}\n收货地址:${res.data.data.address}`;
        this.billTable.bill = `税号:${res.data.data.taxCode}\n抬头:${res.data.data.invoiceHeader}`;
      });
    },
    toDismiss(e) {
      if (e.rejectReason) {
        this.dismissTable.reason = e.rejectReason;
      }
      this.dismissDetailSet = true;
    },
    toWithdraw(res) {
      // this.$router.push(`/income/income-withdraw?data=${JSON.stringify(res)}`);
      this.$router.push({
        path: "/income-withdraw",
        query: { data: JSON.stringify(res) },
      });
    },
  },
  created() {
    this.queryWithdrawlList();
    this.queryStatistics();
  },
};
</script>
<style lang="scss">
.income-detail-wrap {
  .invoice-dialog {
    .sendInput {
      textarea {
        min-height: 90px !important;
      }
    }
  }
  .paginationBox {
    text-align: center;
  }
  .btnBase {
    height: 32px;
    margin-top: 5px;
    line-height: 0px;
  }
  background-color: #f7f7f7;
  > .header {
    .search {
      margin-top: 40px;
      // margin-bottom: 20px;
    }
    padding-left: 50px;
    background-color: #fff;
    .title {
      height: 80px;
      line-height: 80px;
      color: #333333;
      font-size: 18px;
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 0px;
        border-bottom: 1px solid #f2f3f3;
        right: 0;
        bottom: 0;
        left: -50px;
        position: absolute;
      }
    }
    .el-range-separator {
      width: 20px;
    }
    .chart-data {
      border-bottom: 1px solid #f2f3f3;
      display: flex;
      padding: 25px;
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 0px;
        border-bottom: 1px solid #f2f3f3;
        right: 0;
        bottom: 0;
        left: -50px;
        position: absolute;
      }
      .chart {
        width: 150px;
        margin-right: 100px;
        .circle {
          display: flex;
          width: 150px;
          height: 150px;
          background-color: #ff9c00;
          border-radius: 75px;
          justify-content: center;
          align-items: center;
          font-size: 26px;
          font-weight: bold;
          color: #fff;
        }
        .bgColor {
          &1 {
              background-color: #ffae00;
          }
          &2 {
              background-color: #009eff;
          }
          &3 {
              background-color: #43deaa;
          }
          &4 {
              background-color: #fe6a6a;
          }
          &5 {
              background-color: #b3b3b3;
          }
        }
        .title-name {
          padding-top: 15px;
          text-align: center;
        }
      }
    }
  }
  .table-list {
    background: #f7f7f7;
    overflow: hidden;
    .summary {
      border-top: 20px solid #eee;
      display: flex;
      align-items: center;
      width: 100%;
      background-color: #fafafa;
      padding-left: 50px;
      height: 80px;
      .item {
        margin-right: 40px;
      }
    }
    .tabledata-con {
      padding: 10px 50px 40px 50px;
      background: #fff;
      overflow: hidden;
      .table-btn {
        margin-right: 10px;
        cursor: pointer;
        color: #ff9c00;
      }
    }
  }
}
</style>
